import { createFileRoute, redirect } from '@tanstack/react-router';

import { MemoryTabsPage } from '@/features/echonotes/MemoryTabsPage';
import { userStore } from '@/stores/user.store';
import { Routes } from '@/types/routes';

export const Route = createFileRoute('/_authenticated/echonotes/')({
  beforeLoad() {
    if (userStore.isInternalUser) {
      return;
    }

    throw redirect({
      to: Routes.Chats as string,
      replace: true,
    });
  },
  component: MemoryTabsPage,
});
